import { useMutation } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';
import { api } from '@/modules/common/api/index.ts';

export const useClearNewHolderOnboardedNotifications = () => {
  const auth = useAuth();

  return useMutation({
    mutationFn: async () => {
      await api.v1.clearNewHolderOnboardedNotificationV1SrRegistersCurrentNewHolderOnboardedNotificationPatch();
    },
    onSuccess: async () => {
      await auth.signinSilent();
    },
  });
};
